export * from './tellent-groups.types';
export * from './tellent-groups.store';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentGroupsEffects } from './tellent-groups.effects';
import { TellentGroupsNamespace, TellentGroupsReducer } from './tellent-groups.store';

export const tellentGroupsEffectsProvider = provideEffects([TellentGroupsEffects]);

export const tellentGroupsStateProvider = provideState(
  TellentGroupsNamespace,
  TellentGroupsReducer,
);

export const tellentGroupsData = [tellentGroupsEffectsProvider, tellentGroupsStateProvider];

export { TellentGroupsDataModule } from './tellent-groups.module';
